import { IconArrowLeft } from "@tabler/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useRequestResetPasswordToken } from "#modules/auth/view/useRequestResetPasswordToken";
import { ROUTES } from "#shared/routes";
import { Container } from "#shared/view/components/Container";
import { Form } from "#shared/view/components/Form";
import { Button } from "#shared/view/designSystem/Button";

import { Title } from "../../../shared/view/components/Title";

export const ResetPasswordRequestPage = () => {
  const navigate = useNavigate();

  const [didResetEmail, setDidResetEmail] = useState(false);
  const { resetPassword, isPending: isReseting } = useRequestResetPasswordToken({
    onSuccess: () => setDidResetEmail(true),
  });

  const handleSubmit = async (data: { email: string }) => {
    resetPassword(data.email);
  };

  const { t } = useTranslation();

  const goBack = () => {
    navigate(ROUTES.login);
  };

  return (
    <Container style={{ marginTop: 40 }}>
      <img
        alt=""
        src="/fabera-logo.png"
        width="70"
        height="70"
        className="d-inline-block align-top"
        style={{ marginBottom: 20 }}
      />
      <Title order={2}>{t("login.forgotPassword")}</Title>
      <Title order={5}>{t("login.enterYourEmailToResetYourPassword")}</Title>
      {didResetEmail ? (
        <p>{t("login.anEmailHasBeenSent")}</p>
      ) : (
        <Form
          sections={[
            {
              title: "",
              fields: [
                {
                  key: "email",
                  label: t("login.emailAddress"),
                  type: "text",
                  required: true,
                },
              ],
            },
          ]}
          onSubmit={handleSubmit}
          isLoading={isReseting}
          SubmitComponent={({ isLoading }) => (
            <Button size="lg" type="submit" loading={isLoading}>
              {t("login.resetPassword")}
            </Button>
          )}
        />
      )}

      <br />
      <Button leftSection={<IconArrowLeft />} color="gray" onClick={goBack}>
        {t("login.back")}
      </Button>
    </Container>
  );
};
